import { Component, Input, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';

import { BrigadePopoverService } from './brigade-popover.service';
import { Enums } from '../../../configs/Enums';
import { WORK_SHIFT_PATHS } from '../../../pages/work-shift/work-shift';
import { AppComponent } from 'src/app/app.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-brigade-popover',
  templateUrl: './brigade-popover.component.html',
  styleUrls: ['./brigade-popover.component.scss'],
  standalone: false,
})
export class BrigadePopoverComponent implements OnInit {
  WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  brigadeLoading = false;
  brigadeError = null;
  brigadeExtra = null;

  @Input() brigade;

  constructor(
    private brigadePopoverService: BrigadePopoverService,
    @Inject(AppComponent) private appComp: AppComponent
  ) {}

  ngOnInit() {}

  getBrigade() {
    this.brigadeLoading = true;
    this.brigadePopoverService.getBrigade(this.brigade.id || this.brigade.brigade_id).subscribe(
      (response) => {
        this.brigadeLoading = false;
        this.brigadeError = null;
        this.brigadeExtra = response['data'];
        this.appComp.update();
      },
      (error) => {
        console.log(error);
        this.brigadeError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        this.appComp.update();
      }
    );
  }

  toggleWithBrigadeContext(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
      this.getBrigade();
    }

    this.appComp.update();
  }
}
